// extracted by mini-css-extract-plugin
module.exports = {"first":"main-page_first__QFzSg","second":"main-page_second__A_fPm","comments":"main-page_comments__5SOPr"};